import type { ReactNode } from 'react'

interface TaskPaneLayoutProps {
  children: ReactNode
}

/**
 * Root layout for the Office task pane.
 * Fills available width — Office controls the pane size.
 */
export function TaskPaneLayout({ children }: TaskPaneLayoutProps) {
  return (
    <div className="flex flex-col h-screen w-full overflow-hidden">
      {children}
    </div>
  )
}
